<template>
	<div class="app" >
		<div class="small-head" @click.self="closemenu">
			<div class='small-head-box1'>
				<img src="@/assets/logo.png" />
			</div>
			
			<div class='small-head-box2'  >
				<img src="@/assets/switch.png" @click="changelang" />
				<img src="@/assets/small/cebian.png" alt="" @click="switchmenu" />
				<div class="menubox" v-show="menuflag">
					<a href="#page1" @click="closemenu"><div>{{langflg?'首页':'HOME'}}</div></a>
					<a href="#page2" @click="closemenu"><div>{{langflg?'集团介绍':'GROUP INTRODUCTION'}}</div></a>
					<a href="#page3" @click="closemenu"><div>{{langflg?'全球服务':'GLOBAL'}}</div></a>
					
					<a href="#page5" @click="closemenu"><div>{{langflg?'公司优势':'STRENGTHS'}}</div></a>
					<a href="#page6" @click="closemenu"><div>{{langflg?'服务能力':'SERVICEABILITY'}}</div></a>
					<a href="#page7" @click="closemenu"><div>{{langflg?'解决方案':'SOLUTION'}}</div></a>
					<a href="#page8" @click="closemenu"><div>{{langflg?'联系我们':'CONTACT US'}}</div></a>
				</div>
			</div>
		</div>
		<div class="small-content"  @click="closemenu">
			<div class="small-page"  >
				<div class="small-page1-box" id="page1"  >
					<img src="@/assets/small/bg-1.png" alt="" />
					<img src="@/assets/small/bg-2.png" alt=""  />
					<div class="small-page1-title">
						<img src="@/assets/leftyuan.png" alt="" />
						<div>{{langflg?'蚂蚁链控股集团':'Ant Group '}}</div>
						<div v-if="langflg">'技术领先、质量至上、用芯智造'</div>
						<div v-if='langflg'></div>
						<div v-if="!langflg" style="font-size: 18px;">Leading technology, quality first,  </div>
						<div v-if='!langflg' style="font-size: 18px;">and Smart Manufacturing with Core</div>
						<a href="#page2" v-if="langflg"><img src="@/assets/anniu.png" alt="" /></a>
						<a href="#page2" v-if="!langflg"><img src="@/assets/chakangengduo.png" alt="" /></a>
					</div>
				</div>
				<div class="small-page-white" id="page2" >
					<div class="small-page-title-left" v-if='langflg' >
						集团介绍/----
					</div>
					<div class="small-page-title-left" v-if="!langflg" style="top: 60px;left: -70px;">
						GROUP INTRODUCTION/----
					</div>
					<div class="small-page-title" v-if="langflg">
						<div>中国香港</div><br />
						<div>蚂蚁链控股集团</div>
					</div>
					<div class="small-page-title" v-if="!langflg">
						<div>Hong Kong, China</div><br />
						<div style="font-size: 20px;">Ant Group</div>
					</div>
					<div class="small-2">
						香港蚂蚁控股集团(简称:蚂蚁控股)是一家集投资、区块链技术、人工智能大数据、云计算、区块链金融、外汇行生品交易、营销、传媒、服务器贸易、产业供应链等为一体，形成以金融助力科技为主的多元化产业投资控股公司。<br>
						Hong Kong Ant Holdings Group (referred to as Ant Holdings) is a diversified industrial investment holding company that integrates investment, blockchain technology, artificial intelligence big data, cloud computing, blockchain finance, foreign exchange banking and product trading, marketing, media, server trade, industrial supply chain, etc., forming a focus on financial support technology.
					</div>
					<img src="@/assets/page2img.png" alt="" style="width: 100%;box-sizing: border-box;padding: 10px 20px 40px;" v-if="langflg" />
					<img src="@/assets/page2img-2.png" alt="" style="width: 100%;box-sizing: border-box;padding: 10px 20px 40px;" v-if="!langflg" />
				</div>
				
				<div class="small-page-black" id="page3" >
					<div class="small-page-title-left" style="color: #fff;"  v-if="langflg" >
						全球服务/----
					</div>
					<div class="small-page-title" style="color: #fff;"  v-if="langflg" >
						<div>全球服务</div>
					</div>
					
					<div class="small-page-title-left" style="color: #fff;" v-if="!langflg" >
						GLOBAL/----
					</div>
					<div class="small-page-title" style="color: #fff;"  v-if="!langflg" >
						<div>GLOBAL</div>
					</div>
					
					<div class="small-3">
						<div class="small-3-1">
							<div class="small-3-1-1">
								<img src="@/assets/ditu.png" alt="" v-if="langflg" />
								<img src="@/assets/ditu.png" alt="" v-if="langflg"  />
								<img src="@/assets/ditu3.png" alt=""  v-if="!langflg"  />
								<img src="@/assets/ditu3.png" alt=""  v-if="!langflg"/>
							</div>
						</div>
					</div>
				</div>
				
				
				
				<div class="small-page-white" style="min-height: 100vh;" id="page5">
					<div class="small-page-title-left"  v-if="langflg"  >
						公司优势/----
					</div>
					<div class="small-page-title" v-if="langflg"  >
						<div>公司优势</div>
					</div>
					
					<div class="small-page-title-left" v-if="!langflg" style="left:-5px;top: 10px;" >
						Strengths/----
					</div>
					<div class="small-page-title" v-if="!langflg" >
						<div>Strengths</div>
						<div></div>
					</div>
					
					<div style="width: 100%;position: relative;">
						<img src="@/assets/xxxx1.png" alt="" style="width: 100%;margin-top: 40px;" v-if="langflg"  />
						<img src="@/assets/small/sj-2.png" alt="" style="width: 100%;margin-top: 40px;" v-if="!langflg" />
					</div>
					
				</div>
				<div class="small-page-black" id="page6" >
					<div v-if="langflg" class="small-page-title-left" style="color: #fff;">
						服务能力/----
					</div>
					<div v-if="langflg" class="small-page-title" style="color: #fff;">
						<div>服务能力</div>
					</div>
					<div v-if="!langflg" class="small-page-title-left" style="color: #fff;top: 10px;left: -20px; ">
						Serviceability/----
					</div>
					<div v-if="!langflg" class="small-page-title" style="color: #fff;">
						<div>Serviceability</div>
					</div>
					<div class="small-6">
						<div class="small-6-box" v-for="i in 36" :key="i">
							<img :src='"@/assets/zanzhu/z ("+i+").png"' />
						</div>
					</div>
				</div>
				<div class="small-page-white" id="page7" >
					<div class="small-page-title-left" v-if="langflg" >
						解决方案/----
					</div>
					<div class="small-page-title-left" v-if="!langflg" style="top: 15px;left: -10px;" >
						SOLUTION/----
					</div>
					<div class="small-page-title" v-if="langflg" style="padding-right: 10px !important;" >
						<div style="font-size: 28px;">超算&隐私计算技术服务</div>
						<div>服务器定制</div>
					</div>
					<div class="small-page-title" v-if="!langflg"  >
						<div style="font-size: 20px;">Supercomputing&Privacy </div>
						<div style="font-size: 20px;">Computing Technology Services customization</div>
					</div>
					<div class="small-7">
						<div v-if="langflg" >
							<img src="@/assets/small/sj-3.png" alt="" style="width: 100%;" />
						</div>

						<div v-if="!langflg" >
							<img src="@/assets/small/sj-4.png" alt="" style="width: 100%;"  />
						</div>


					</div>
				</div>
				<div class="small-page-black" id="page8" style="height: calc(100vh - 50px);" >
					<div v-if="langflg" class="small-page-title-left" style="color: #fff;">
						联系我们/----
					</div>
					<div v-if="langflg" class="small-page-title" style="color: #fff;">
						<div>联系我们</div>
					</div>
					<div v-if="!langflg" class="small-page-title-left" style="color: #fff;left: -10px;">
						Contact Us/----
					</div>
					<div v-if="!langflg" class="small-page-title" style="color: #fff;">
						<div>Contact Us</div>
					</div>
					<div class="small-8">
						<div class="small-8-1"><el-input v-model="mes.name" placeholder="Enter Your Name" ></el-input></div>
						<div class="small-8-1"><el-input v-model="mes.email" placeholder="Enter Your E-mail"></el-input></div>
						<div class="small-8-1"><el-input v-model="mes.message" placeholder="Type Message Here" type="textarea" :rows="5"></el-input></div>
						<div class="small-8-2" @click="sendmsg">SEND MESSAGE</div>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return{
			mes:{
				name:'',
				email:'',
				message:''
			},
			pageflag:true,
			menuflag:false,
			langflg:true
		}
	},
	methods:{
		changelang(){
			this.langflg=!this.langflg
		},
		gopage(num){
			this.$refs.pageswitch.setActiveItem(num)
		},
		mousewheelnow(e){
			console.log( e.wheelDelta);
			if(this.pageflag){
				this.pageflag=false
				if( e.wheelDelta<0){
					this.$refs.pageswitch.next()
				}else{
					this.$refs.pageswitch.prev()
				}
				setTimeout(()=>{
					this.pageflag=true
				},300)
			}
			
		},
		pageup(){
			this.$refs.pageswitch.next()
		},
		pagedown(){
			this.$refs.pageswitch.prev()
		},
		switchmenu(){
			this.menuflag=!this.menuflag
		},
		closemenu(){
			this.menuflag=false
		},
		sendmsg(){
			if(this.mes.email==''||this.mes.message==''||this.mes.name==''){
				this.$message({
				  message: '请填写完整信息',
				  type: 'warning'
				});
			}
			axios({
				method: "post",
				url: "/xx",
				params:{ 
					...this.mes
				}
			}).then(x=>{
				if(x.data=='发送成功'){
					this.$message({
					  message: '发送成功',
					  type: 'success'
					});
				}else{
					this.$message({
					  message: '发送失败',
					  type: 'warning'
					});
				}
			})
		}
	}
}
</script>

<style scoped>
body{
	
	position: relative;
	
}
.app{
	width: 100%;
	height: 100%;
	position: fixed;
	display: flex;
	flex-direction: column;
	top: 0;
	left: 0;
}
.small-head{
	width: 100%;
	padding: 15px 16px;
	background-color: rgb(11, 33, 56);
	flex-grow: 0;
	flex-shrink: 0;
	position: relative;
	height:30px;
	
}
.small-content{
	width: 100%;
	flex-grow: 1;
	flex-shrink: 1;
	overflow: auto;
	position: relative;
}


.small-head-box1{
	width: 210px;
	height: 25px;
	position: absolute;
	left: 16px;
}
.small-head-box1>img{
	height: 30px;
}
.small-head-box1>div:nth-child(2){
	display: inline-block;
	font-size: 21px;
	line-height: 25px;
	position: relative;
	top: -8px;
	left: 20px;
	color: #fff;
}
.small-head-box2{
	width: 130px;
	height: 30px;
	position: absolute;
	right: 32px;
	
}
.small-head-box2>img:nth-child(1){
	width: 30px;
	height: 30px;
	position: absolute;
	left: 16px;
}
.small-head-box2>img:nth-child(2){
	width: 30px;
	height: 30px;
	position: absolute;
	right: 16px;
}




.small-page{
	width: 100%;
	height: 100%;
	position: absolute;
	overflow: auto;
}
.small-page1-box{
	width: 100%;
	height: 100vh;
	position: relative;
}
.small-page1-box>img:nth-child(1){
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: 1;
	object-fit: cover;
}
.small-page1-box>img:nth-child(2){
	width: 80%;
	position: absolute;
	z-index: 2;
	bottom: 50px;
	right: 30px;
}
.small-page1-title{
	width: 100%;
	box-sizing: border-box;
	padding: 0 20px;
	height:260px;
	position: absolute;
	z-index: 3;
	overflow: hidden;
	top: 0px;
	bottom: 120px;
	margin-top: auto;
	margin-bottom: auto;
}
.small-page1-title>img:nth-child(1){
	width: 16px;
	height: 16px;
	position: relative;
}
.small-page1-title>div:nth-child(2){
	display: inline-block;
	font-size: 22px;
	color: #fff;
	margin-left: 12px;
}
.small-page1-title>div:nth-child(3){
	margin-top: 36px;
	font-size: 36px;
	color: #fff;
}
.small-page1-title>div:nth-child(4){
	margin-top: 5px;
	font-size: 28px;
	color: #fff;
}
.small-page1-title>a:nth-child(5)>img{
	width: 167px;
	height: 45px;
	position: absolute;
	bottom: 0;
}
.small-page-white{
	width: 100%;
	background-color: #fff;
	position: relative;
}
.small-page-black{
	width: 100%;
	background-color: #001C1C;
	position: relative;
}
.small-page-title-left{
	display: inline-block;
	font-size: 20px;
	transform: rotate(90deg);
	position: relative;
	margin-top: 70px;
	margin-left: -30px;
	font-weight: 100;
}
.small-page-title{
	font-size: 30px;
	width: 100%;
	padding: 0px 50px;
	font-weight: 100;
	box-sizing: border-box;
}
.small-page-title>div:nth-child(1){
	border-bottom: 20px solid #783CEC;
	line-height: 0;
	display: inline-block;
	padding: 0 5px;
	box-sizing: border-box;
}
.small-page-title>div:nth-child(3){
	width: ;
	display: inline-block;
	padding: 0 5px;
	box-sizing: border-box;
}
.small-2{
	padding: 20px 50px;
	width: 100%;
	box-sizing: border-box;
	word-break: break-all;
	text-align: justify;
	line-height: 2;
	font-weight: 100;
	color: #616361;
}
.small-3{
	width: 100%;
	height: 80vh;
	box-sizing: border-box;
	padding: 30px 50px;
}
.small-3-1{
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
	
}
.small-3-1-1{
	position: absolute;
	height: 100%;
	white-space: nowrap;
	animation: 25s linear rightMove infinite;
}
.small-3-1-1>img{
	position: relative;
	height: 79vh;
}
@keyframes rightMove {
	from {
		left: 0;
	}
	to {
		
		left:-192vh;
	}
}

.small-4{
	width: 100%;
	box-sizing: border-box;
	padding: 20px 30px;
	position: relative;
}
.small-4-1{
	padding: 16px;
	background: rgba(0, 28, 28, 0.03);
	margin-bottom: 30px;
	position: relative;
}
.small-4-1-1{
	position: relative;
	width: 100%;
	display: flex;
}
.small-4-1-1>img:nth-child(1){
	width: 80px;
	height: 80px;
	position: relative;
	flex-wrap: 0;
	flex-shrink: 0;
}
.small-4-1-text1{
	width: 100%;
	box-sizing: border-box;
	padding:0px 0px 0 5px;
	font-size: 15px;
	line-height: 23px;
	position: relative;
	font-weight: 100;
}
.small-4-1-text2{
	width: 100%;
	box-sizing: border-box;
	padding:10px 0px 0px;
	font-size: 13px;
	font-weight: 100;
	position: relative;
	text-align: left;
	
}
.small-4-1-text2>div>div:nth-child(1){
	display: inline-block;
	width: 12px;
	height: 12px;
	background-color: #783CEC;
	border-radius: 50%;margin-right: 5px;
}
.small-4-1-text2>div>div:nth-child(2){
	display: inline-block;
	margin-left: 5px;
}


.small-5-1{
	width: 90%;
	position: absolute;
	bottom: 0;
	left: 5%;
}
.small-5-2{
	width: 100%;
	position: absolute;
	bottom: 25px;
	text-align: center;
	font-size: 16px;
	font-weight: 100;
	color: #303330;
}
.small-5-3{
	width: 90%;
	position: absolute;
	left: 5%;
	top: 220px;
}
.small-6{
	width: 100%;
	padding: 30px;
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
}
.small-6-box{
	width: 24%;
	flex-grow: 1;
	flex-shrink: 0;
	position: relative;
	margin-top: 8px;
}
.small-6-box>img{
	width: 90%;
	margin-left: 5%;
	position: relative;
	display: inline-block;
}
.small-7{
	width: 100%;
	position: relative;
	box-sizing: border-box;
	padding: 20px 20px;
	box-sizing: border-box;
	word-break: break-all;
	text-align: justify;
	line-height: 2;
	font-weight: 100;
	color: #616361;
}

.card{
	width: 100%;
	border-radius: 15px;
	border: 1px solid #e6e6e6;
	padding: 15px;
}
.card:nth-child(2){
	margin-top: 20px;
}
.card>div:nth-child(1){
	width: 100%;
	
}
.card>div:nth-child(1)>div>div:nth-child(1){
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background-color: #783CEC;
	display: inline-block;
	position: relative;
	top: 1px;
	margin-right: 8px;
}
.card>div:nth-child(1)>div{
	display: inline-block;
	margin-left: 8px;
	font-size: 20px;
}
.small-8{
	width: 100%;
	box-sizing: border-box;
	padding: 20px;
	margin-top: 30px;
}
.small-8-1{
	width: 100%;
	margin-top: 20px;
	padding: 0 30px;
	box-sizing: border-box;
}
.small-8-2{
	padding: 10px 20px;
	background-color: #783CEC;
	font-size: 17px;
	color: #fff;
	font-weight: 100;
	margin-left: 30px;
	margin-top: 20px;
	display: inline-block;
	user-select: none;
}
.small-8-3{
	width: 100%;
	box-sizing: border-box;
	padding: 0 30px;
	font-size: 17px;
	font-weight: 100;
	color: #fff;
	margin-top: 50px;
}
.small-8-4{
	width: 100%;
	box-sizing: border-box;
	padding: 0 30px;
	font-size: 13px;
	font-weight: 100;
	color: #fff;
	margin-top: 15px;
}
.small-8-5{
	width: 100%;
	box-sizing: border-box;
	padding: 0 30px;
	font-size: 15px;
	color: #783CEC;
	margin-top: 30px;
	line-height: 3;
}
 /deep/.el-input__inner {
	background-color: rgba(255, 255, 255, 0.2) !important;
	color: #fff;
	border: 1px  rgba(255, 255, 255, 0.2);
}
 /deep/ .el-textarea__inner{
	background-color: rgba(255, 255, 255, 0.2) !important;
	color: #fff;
	border: 1px  rgba(255, 255, 255, 0.2);
 }
 
 .menubox{
	 width: 170px;
	 color: #fff;
	 font-weight: 100;
	 font-size: 17px;
	 background-color: rgba(48, 51, 48, 0.5);
	 position: fixed;
	 z-index: 20;
	 top: 60px;
	 right: 20px;
	 border-radius: 10px;
	 padding-top: 5px;
	 padding-bottom: 5px;
 }
 .menubox>a{
	 width: 100%;
	 text-decoration: none;
 }
 .menubox>a:hover{
	 color: #fff;
 }
 .menubox>a:active{
 	 color: #fff;
 }
 .menubox>a:link{
 	 color: #fff;
 }
 
 .menubox>a:visited{
 	 color: #fff;
 }
 .menubox>a>div{
	 width: 100%;
	 box-sizing: border-box;
	 padding: 10px 30px;
	 user-select: none;
 }
</style>